import React from 'react';

const Pricing: React.FC = () => (
  <div className="p-4">
    <h1 className="text-2xl font-bold">Pricing</h1>
    <p>Placeholder for Pricing page.</p>
  </div>
);

export default Pricing;
